import Image from 'next/image'
import { Link } from '@/components/site/link'
import { Badge } from '@/components/ui/badge'
import type { ProofCardContent } from '@/types/site'

/**
 * Case-study card in the v2 proof format: visible tag row (pillar +
 * stage/bottleneck), what we started from and owned, and a result line
 * at the bottom. Cards without an href (placeholders) render unlinked.
 */
export function ProofCard({ card }: { card: ProofCardContent }) {
  const body = (
    <>
      {card.image ? (
        <div className="home-cs-image">
          <Image src={card.image} alt={card.company} fill sizes="(max-width: 809px) 100vw, 33vw" />
          <div className="home-cs-image-overlay" />
        </div>
      ) : null}
      <div className="home-cs-body">
        <div className="home-cs-tags">
          {card.tags.map((tag) => (
            <Badge key={tag} variant="outline" className="home-cs-tag">
              {tag}
            </Badge>
          ))}
        </div>
        <h3 className="home-cs-company">{card.company}</h3>
        <p className="home-cs-copy">{card.body}</p>
        {card.result ? <p className="home-cs-result">{card.result}</p> : null}
      </div>
    </>
  )
  return card.href ? (
    <Link href={card.href} className="home-cs-card">
      {body}
    </Link>
  ) : (
    <article className="home-cs-card">{body}</article>
  )
}
